export { HousingApplicationCard as default } from './index';

